// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  help: {},
};

export default {
  actions,
  mutations,
  getters,
  state,
};
